module.exports = __webpack_public_path__ + "img/post.f3511fb8.png";